__turbopack_context__.v({
  "className": "fontlocal_ab4a6c65-module__ORGejq__className",
  "variable": "fontlocal_ab4a6c65-module__ORGejq__variable",
});
